module.exports = __webpack_public_path__ + "img/sun-cloud.fb0cf44e.svg";